import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectListItems } from "../../../../../../redux/library/selector";
import { selectPlansListItems } from "../../../../../../redux/plans/selector";
import { plans } from "../../../../../../redux/plans/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table";


const MarketingPlansContainer = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const itemsData = useSelector(selectPlansListItems)
  const libraryData = useSelector(selectListItems)
  const [columnDefs,setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Plan',searchField: 'Name', sortable: true, filter: true, filterType: 'text'},
      { field: 'CampaignFrequencyId', headerName: 'Frequency', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library:libraryData?.result?.CampaignFrequency } },
      { field: 'IsEmailCampaignIncluded', headerName: 'Email', cellRenderer: 'yesNoRenderer' },
      { field: 'IsSMSCampaignIncluded', headerName: 'SMS', cellRenderer: 'yesNoRenderer' },
      // { field: 'IsWhatsappCampaignIncluded', headerName: 'Whatsapp', cellRenderer: 'yesNoRenderer' },
      { field: 'StartDate', headerName: 'Start Date', isDateValueFormat:true},
      { field: 'EndDate', headerName: 'End Date',isDateValueFormat:true }
      ]);
    }

    const fetchPlan=()=>{
      dispatch(plans.list({
        url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/list`,
        entity:'plans',
        jsonData:{
          "PageNumber": pageData,
            "PageSize": pageSize,
        }
      }))
    }
  
    useEffect(() => {
        createColumnDefs()
        fetchPlan()
    },[pageData,pageSize])
  
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  
  
  const handleDelete=(data: any)=>{
    dispatch(plans.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/delete`,
      entity: 'plans',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
  })).then(() => {
    fetchPlan()
  });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.Id}`)
  }
  const handleReloadData = () => {
    fetchPlan()
  }
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Plans</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },
    
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handleReloadData(),
    },
  ];

  const handleSearch = (data: any) => {
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } 
    dispatch(plans.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/list`,
      entity: 'plans',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }
  
  // const additionButtons: any = [
  //   {
  //     name: 'Add Plans',
  //     callback: () => handleAdd(),
  //   }
  // ];

 

  return (
  <>
    {itemsData?.isLoading ? 
    <PageLoader /> : 
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} setPageSize={setPageSize} onEdit={handleEdit}  enableFilter={true}
    onSearch={handleSearch} additionButtons={additionButtons} headingName="Plans" />
    }
  </>
  );
};

export default MarketingPlansContainer;


